import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';

const OverviewTitle = () => (
  <Box
    my="20px"
    px="8px"
  >
    <Heading
      family="secondary"
      size="2xl"
      weight="bold"
    >
      Check deposit submitted!
    </Heading>
  </Box>
);

export default OverviewTitle;
